/**
 * i18n helper for event management translations
 * Provides locale-aware fallbacks to prevent RO/EN mixing
 */

type Locale = 'ro' | 'en';

interface FallbackMap {
  [key: string]: {
    ro: string;
    en: string;
  };
}

const fallbacks: FallbackMap = {
  'events.form.generalInfo': {
    ro: 'Informații Generale',
    en: 'General Information',
  },
  'events.form.guests': {
    ro: 'Invitați',
    en: 'Guests',
  },
  'events.form.template.home': {
    ro: 'Acasă',
    en: 'Home',
  },
  'events.form.template.ourStory': {
    ro: 'Povestea Noastră',
    en: 'Our Story',
  },
  'events.form.template.giftRegistry': {
    ro: 'Listă Cadouri',
    en: 'Gift Registry',
  },
  'events.form.template.celebratingWithLove': {
    ro: 'Sărbătorind cu Dragoste',
    en: 'Celebrating with Love',
  },
  'events.form.template.loading': {
    ro: 'Se încarcă...',
    en: 'Loading...',
  },
  'events.form.template.fulfilled': {
    ro: 'Împlinit',
    en: 'Fulfilled',
  },
  'events.form.template.universalGiftNote': {
    ro: 'Notă Cadou Universală',
    en: 'Universal Gift Note',
  },
  'events.form.parentsLabel': {
    ro: 'Părinți',
    en: 'Parents',
  },
  'events.form.godparentsLabel': {
    ro: 'Nași',
    en: 'Godparents',
  },
  'events.form.template.theCelebration': {
    ro: 'Sărbătoarea',
    en: 'The Celebration',
  },
  'events.form.template.kindlyRespond': {
    ro: 'Te rugăm să răspunzi',
    en: 'Kindly Respond',
  },
  'events.form.template.rsvpToWedding': {
    ro: 'Confirmă prezența',
    en: 'Confirm attendance',
  },
  'events.form.template.momentsWeTreasure': {
    ro: 'Momente pe care le prețuim',
    en: 'Moments we treasure',
  },
  'events.form.template.saveTheDate': {
    ro: 'Salvează data',
    en: 'Save the date',
  },
  'events.form.template.howItAllStarted': {
    ro: 'Cum a început totul',
    en: 'How it all started',
  },
  'events.form.template.bestIsYetToCome': {
    ro: 'Cel mai bun este încă să vină',
    en: 'The best is yet to come',
  },
  'events.form.template.countdownBegan': {
    ro: 'Contorul a început',
    en: 'The countdown has begun',
  },
  'events.form.template.countdownTitle': {
    ro: 'Numărătoarea inversă',
    en: 'Countdown',
  },
  'events.form.template.baptismSchedule': {
    ro: 'Programul botezului',
    en: 'Baptism schedule',
  },
  'events.form.template.viewDirections': {
    ro: 'Vezi indicații',
    en: 'Get directions',
  },
  'events.form.template.viewOnMap': {
    ro: 'Vezi pe hartă',
    en: 'View on map',
  },
  'events.form.template.madeWithLove': {
    ro: 'Creat pe Jubiel',
    en: 'Created on Jubiel',
  },
  'events.form.template.untilLivesBecomeOne': {
    ro: 'Până când viețile noastre devin una',
    en: 'Until our lives become one',
  },
  'events.form.untilBigDay': {
    ro: 'până la marele eveniment!',
    en: 'until the big day!',
  },
  'events.form.timeline': {
    ro: 'Cronologia ceremoniei',
    en: 'Ceremony timeline',
  },
  'events.form.datetime': {
    ro: 'Data și ora',
    en: 'Date & time',
  },
  'events.form.familySection': {
    ro: 'Familie și Nuntă',
    en: 'Family & Wedding Party',
  },
  'events.form.gallery': {
    ro: 'Galerie',
    en: 'Gallery',
  },
  'events.actions': {
    ro: 'Acțiuni rapide',
    en: 'Quick Actions',
  },
  'events.share.title': {
    ro: 'Distribuie evenimentul',
    en: 'Share Event',
  },
  'events.giftRegistry': {
    ro: 'Registru Cadouri',
    en: 'Gift Registry',
  },
  'events.form.rsvpNow': {
    ro: 'RSVP Acum',
    en: 'RSVP Now',
  },
  'events.form.createdOnJubiel': {
    ro: 'Creat pe Jubiel',
    en: 'Created on Jubiel',
  },
  'events.form.createYourWeddingSite': {
    ro: 'Creează site-ul tău de nuntă gratuit',
    en: 'Create your wedding site for free',
  },
  'events.form.privacyOptions': {
    ro: 'Opțiunile tale de confidențialitate',
    en: 'Your privacy options',
  },
  'events.notFound': {
    ro: 'Evenimentul nu a fost găsit',
    en: 'Event not found',
  },
  'events.form.template.gallery': {
    ro: 'Galerie',
    en: 'Gallery',
  },
  'events.form.template.rsvp': {
    ro: 'Confirmă prezența',
    en: 'Confirm attendance',
  },
  'events.form.template.cadouri': {
    ro: 'Cadouri',
    en: 'Gifts',
  },
  'events.form.template.allItems': {
    ro: 'Toate Articolele',
    en: 'All Items',
  },
  'events.form.template.progress': {
    ro: 'Progres',
    en: 'Progress',
  },
  'events.form.template.viewDetails': {
    ro: 'Vezi Detalii',
    en: 'View Details',
  },
  'events.form.template.contributeGift': {
    ro: 'Contribuie Cadou',
    en: 'Contribute Gift',
  },
  'events.form.template.rsvpNow': {
    ro: 'Confirmă prezența',
    en: 'Confirm attendance',
  },
  'events.form.template.share': {
    ro: 'Distribuie',
    en: 'Share',
  },
  'events.form.template.day': {
    ro: 'zi',
    en: 'day',
  },
  'events.form.template.days': {
    ro: 'zile',
    en: 'days',
  },
  'events.form.template.hours': {
    ro: 'Ore',
    en: 'Hrs',
  },
  'events.form.template.minutes': {
    ro: 'Min',
    en: 'Mins',
  },
  'events.form.template.seconds': {
    ro: 'Sec',
    en: 'Secs',
  },
  'gifts.contribute': {
    ro: 'Contribuie',
    en: 'Contribute',
  },
  'events.form.template.giftRegistryDescription': {
    ro: 'Prezența ta este cel mai mare cadou. Cu toate acestea, dacă dorești să contribui la viitorul nostru, avem o selecție de articole și experiențe.',
    en: 'Your presence is the greatest gift of all. However, should you wish to contribute to our future, we have curated a selection of items and experiences.',
  },
  'events.form.template.universalGiftNoteDescription': {
    ro: 'Poți contribui în siguranță cu cardul, direct de pe această pagină. Așteptăm cu nerăbdare să împărtășim aceste amintiri cu tine.',
    en: 'You can contribute securely by card, right from this page. We look forward to sharing these memories with you.',
  },
  'events.form.rsvpDescription': {
    ro: 'Confirmă-ți prezența din câteva clicuri.',
    en: 'Confirm your attendance in a few clicks.',
  },
  'events.form.template.foreverAlways': {
    ro: 'Pentru Totdeauna',
    en: 'Forever & Always',
  },
  'events.form.template.eventDetails': {
    ro: 'Detalii Eveniment',
    en: 'Event Details',
  },
  'events.form.template.saveTheDateDescription': {
    ro: 'Suntem foarte încântați să sărbătorim uniunea noastră. Te rugăm să adaugi ziua noastră specială în calendar.',
    en: 'We are so excited to celebrate our union. Please add our special day to your calendar.',
  },
  'events.form.template.saveTheDateDescriptionBaptism': {
    ro: 'Suntem foarte încântați să sărbătorim această zi specială împreună cu voi. Te rugăm să adaugi evenimentul în calendar.',
    en: 'We are delighted to celebrate this special day with you. Please add the event to your calendar.',
  },
};

/**
 * Get locale-aware fallback for a translation key
 * @param key - Translation key
 * @param locale - Current locale ('ro' | 'en')
 * @returns Fallback string matching the locale, or the key if not found
 */
export function getEventsFallback(key: string, locale: Locale): string {
  const fallback = fallbacks[key];
  if (!fallback) {
    return key; // Return key as last resort
  }
  return fallback[locale] || fallback.ro; // Default to RO if locale not found
}

/**
 * Events i18n helper object
 */
export const eventsI18n = {
  get: getEventsFallback,
};

